import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import "./style.css";
import "aos/dist/aos.css";
import App from "./App";
import { BrowserRouter } from "react-router-dom";
import ContextProvider from "./Context/ContextOPen";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <ContextProvider>
      <BrowserRouter>
        <App />
      </BrowserRouter>
    </ContextProvider>
  </React.StrictMode>
);
